import store from "redux/store";
import { setCurrentUser } from "redux/game/action";
import { setIsLoading } from "redux/loader/action";
import alert from "../common/alert";
import { updateUserAttributes } from "../mailchimp";
import getTeamApiCall from "./getTeamApiCall";
import getUserAttributes from "./getUserAttributes";

const onSignIn = async (
  payload,
  do_sign_in_analytics = true,
  join_team_flow_active = null
) => {
  const currentUser = store.getStore().getState().gameReducer.currentUser;
  store.dispatch(setIsLoading(true));
  let profilePicture = payload.picture
    ? payload.picture
    : payload["custom:profile_picture"]
    ? payload["custom:profile_picture"]
    : "profileImage";
  if (payload?.identities?.length > 0) {
    if (payload.identities[0].providerType === "Facebook") {
      let pic = JSON.parse(payload.picture);
      profilePicture = pic.data.url;
    }
  }

  const attributes = await getUserAttributes(payload["cognito:username"]);
  let dataObj = {
    ...currentUser,
    email: attributes.email,
    picture: profilePicture,
    username: attributes.name,
    userId: attributes.Username,
    audio_url: attributes["custom:audioEffect"],
    expires_in: attributes["custom:zoomTokenExpires"],
    access_token: attributes["custom:zoomAccessToken"],
    refresh_token: attributes["custom:zoomRefreshToken"],
    team:
      attributes["custom:promocode"] &&
      (await getTeamApiCall(attributes["custom:promocode"]))
  };

  store.dispatch(setCurrentUser(dataObj));
  if (do_sign_in_analytics) {
    await sign_in_analytics(payload);
    var alertOnce = sessionStorage.getItem("alertOnce") || "";
    if (alertOnce != "yes") {
      alert(200, "You are successfully logged in");
      sessionStorage.setItem("alertOnce", "yes");
    }
  }
  join_team_flow_active === null && store.dispatch(setIsLoading(false));
};

const sign_in_analytics = async (payload) => {
  let mailId = localStorage.getItem("mailId");
  const identityProvider = payload?.identities?.[0]?.providerName;
  if (identityProvider) {
    localStorage.removeItem("utm_medium");
    localStorage.removeItem("utm_source");
    localStorage.removeItem("utm_campaign");
    localStorage.removeItem("utm_content");
  }
  if (mailId) {
    await updateUserAttributes({ "custom:mailchimpsubhash": mailId }, () => {});
  }
};

export default onSignIn;
